import { useMemo } from 'react';
import type { PaymentMetadata } from '@elfsight/widget-stripe-payment';
import { useSettings } from '@wu/widget-core';
import { useDatetime } from '../datetime/datetime-provider';
import { useServices } from '../service/services-provider';

export function usePaymentMetadata(): PaymentMetadata | undefined {
  const { widgetId } = useSettings();
  const { selectedTimeslot } = useDatetime();
  const { currentService } = useServices();

  return useMemo(() => {
    if (!widgetId || !selectedTimeslot || !currentService) {
      return;
    }

    return {
      widgetId,
      paymentContext: 'elfsight_appointment_booking',
      serviceName: currentService.name,
      startDate: selectedTimeslot.from.toISOString(),
      endDate: selectedTimeslot.to.toISOString()
    };
  }, [widgetId, selectedTimeslot, currentService]);
}
